import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { thrash } from '../../assets/svg/other'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal/Modal'
import Table from '../../components/Table'
import { getFormOfEducation, deleteFormOfEducation } from '../../actions/directory'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getCanteenStaffList, deleteCanteenStaff } from '../../actions/directoryCanteen'
import { getUsefulSitesList } from '../../actions/useful_sites'
export default function UsefulSites() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { usefulSiteslist } = useSelector(state => state.useful_sites)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [sortField, setSortField] = useState('title')
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getUsefulSitesList())
  }, [])

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!usefulSiteslist) return []
    return [...usefulSiteslist].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [usefulSiteslist, sortField, sortAsc])


  const openModal = (data) => () => {

    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')


  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteCanteenStaff(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { picture, title, text, link, sid } = data
    return (
      <tr >
        {/* <td onClick={openModal(data)}>{picture}</td> */}
        <td onClick={openModal(data)}>{title}</td>
        <td onClick={openModal(data)}>{text}</td>
        <td>
          <a href={link} >{link}</a>
        </td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ sid, title })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
        />
      }
      <h1>Полезные сайты</h1>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th onClick={() => handleSort('title')} style={{ cursor: 'pointer' }}>Название</th>
            <th>Описание</th>
            <th onClick={() => handleSort('link')} style={{ cursor: 'pointer' }}>Ссылка</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {sortedList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
